import { TicketData } from '@/common/types/support/ticket.type'
import { cn } from '@/common/utils/cn'
import { strategy as statusStrategy } from '@/features/support/external/constants/statusOptions.constant'

type SupportTicketStatusProps = {
  status: TicketData['status']
}

export const SupportTicketStatus = ({ status }: SupportTicketStatusProps) => {
  return (
    <p className={cn(status === 'pending' && 'text-danger-soft')}>
      {statusStrategy[status as keyof typeof statusStrategy]}
    </p>
  )
}
